/* eslint-disable @typescript-eslint/no-explicit-any */
import { EventEmitter } from 'eventemitter3';

type Disposer = () => void;

class EE {
  private ee = new EventEmitter();

  on<T extends string | symbol>(event: T, fn: (...args: any[]) => void, context?: any): Disposer {
    this.ee.on(event, fn, context);
    return () => this.off(event, fn);
  }

  once<T extends string | symbol>(event: T, fn: (...args: any[]) => void, context?: any): Disposer {
    this.ee.once(event, fn, context);
    return () => this.off(event, fn);
  }

  off<T extends string | symbol>(event: T, fn?: (...args: any[]) => void, context?: any, once?: boolean): void {
    this.ee.off(event, fn, context, once);
  }

  emit<T extends string | symbol>(event: T, ...args: any[]): boolean {
    return this.ee.emit(event, ...args);
  }
}

const instance = new EE();
export { instance as EE };
